import React, { useCallback, useEffect, useState, createContext } from 'react'
import { matchRoutes, useLocation } from "react-router-dom"
import paths from 'routes/paths'

// import Cookies from 'js-cookie'

// import logger from 'lib/logger'
import api from 'lib/api'
// import { discectError } from 'lib/utils'

// const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN
// const AUTH0_RETURN = `${window.location.origin}`
// const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_KEY

export const ApplicationContext = createContext()

export const ApplicationProvider = (props) => {

  const contextError = useState(null);
  const contextAgency = useState(null);
  const contextLoading = useState(null);
  const contextConfirm = useState({ type: null, title: null, description: null, meta: null, callback: null });
  const contextAlert = useState({ display: false, title: null, text: null });

  const [agency, setAgency] = contextAgency
  const [isLoading, setIsLoading] = contextLoading // eslint-disable-line
  const [error, setError] = contextError // eslint-disable-line

  const fetchUserAndSave = useCallback(async () => {
    setIsLoading(true)
    try {
      const { user } = await api.users.fetchProfile()
      if (user) {
        if (user.businessType === 'SURETY') {
          window.location = process.env.REACT_APP_SURETY_URI
        }
        const { contract } = await api.agency.fetchAgency(user.id)
        setAgency(() => ({ ...user, contract }))
      } else {
        throw new Error('Could not find user account')
      }
    } catch (e) {
      console.log(e)
      // const error = discectError(e)
      // let isRedirect = false
      // if (error.toLowerCase().indexOf('jwt expired' >= 0)) {
      //   isRedirect = true
      // } else if (error.toLowerCase().indexOf('unauthorized' >= 0)) {
      //   isRedirect = true
      // }
      // if (isRedirect) {
      //   Cookies.remove('token')
      //   window.location = `https://${AUTH0_DOMAIN}/v2/logout?returnTo=${AUTH0_RETURN}&client_id=${AUTH0_CLIENT_ID}`
      // } else {
      //   setError(error)
      // }
    }
    setIsLoading(false)
  }, [setAgency, setIsLoading])

  useEffect(() => {
    // if (!agency && Cookies.get('token')) fetchUserAndSave()
  }, [agency, fetchUserAndSave])

  const useCurrentPath = () => {
    const location = useLocation()
    const [{ route }] = matchRoutes(paths, location)

    return route.path
  }

  const params = { contextError, contextAgency, contextConfirm, contextAlert, contextLoading, fetchUserAndSave, useCurrentPath }

  return (
    <ApplicationContext.Provider value = {params}>
      {props.children}
    </ApplicationContext.Provider>
  )
}
